import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/system";
import { AuthenticatedContext, ModuleContext } from "../../App";
import { GET_DASHBOARD } from "../../graphql/queries";
import { ContainerPaper, DashboardContainer } from "../../components";

const Dashboard = () => {
  const value = useContext(AuthenticatedContext);
  const { setLoading, userRole, getRole } = React.useContext(AuthenticatedContext);
  const { moduleSettings, setModuleSettings, exitSitting } =
    useContext(ModuleContext);
  const history = useHistory();

  function getStatus(placement) {
    if (placement.Sittings.length === 0) {
      return "Start";
    } else if (!placement.Sittings[0].isCompleted) {
      return "Resume";
    } else if (placement.Sittings[0].isCompleted) {
      return "Review";
    } else {
      return "";
    }
  }

  useEffect(() => {
    if (!userRole) getRole();
  }, []);

  const handleExitSitting = useCallback(() => {
    exitSitting();
  }, []);

  useEffect(() => {
    handleExitSitting();
  }, [handleExitSitting]);

  return (
    <ContainerPaper>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {value.userRole === "Student" ? (
          <Typography color="black" gutterBottom variant="h4" sx={{ mb: 2 }}>
            Welcome back{" "}
            {value.user && `${JSON.parse(value.user).student_givenname} (${JSON.parse(value.user).student_login})`} 👋
          </Typography>
        ) : (
          <Typography color="primary" gutterBottom variant="h4" sx={{ mb: 2 }}>
            {value.userRole} Dashboard
          </Typography>
        )}
      </Box>

      {userRole === "Student" && <DashboardContainer />}
    </ContainerPaper>
  );
};

export default Dashboard;
